const LAST_VIEWED_DOCUMENT_ITEM_STATE_KEY = 'lastViewedDocumentItem';

const shouldClearLastViewedDocumentItem = (path: string): boolean => {
  if (path === '/notifications' || path === '/profile') {
    return true;
  }

  return !path.startsWith('/documents');
};

export const useLastViewedDocumentItem = () => {
  return useState<string | null>(LAST_VIEWED_DOCUMENT_ITEM_STATE_KEY, () => null);
};

export const clearLastViewedDocumentItem = () => {
  useLastViewedDocumentItem().value = null;
};

export const syncLastViewedDocumentItemFromRoute = () => {
  const lastViewedItem = useLastViewedDocumentItem();
  const route = useRoute();

  watch(() => route.params.item, (itemId) => {
    if (typeof itemId === 'string' && itemId.length > 0) {
      lastViewedItem.value = itemId;
    }
  }, { immediate: true });

  watch(() => route.path, (path) => {
    if (shouldClearLastViewedDocumentItem(path)) {
      lastViewedItem.value = null;
    }
  }, { immediate: true });
};